<div id="loadingBar">
  <div class="d-flex justify-content-center">
    <div class="row img-logo">
      <div class="col-12 logo-full">
        <img class="image-style" src="/assets/img/geoprod-beta-version3.0.svg" alt="">
      </div>
      <div class="col-12">
        <div class="spinner-border" role="status" >
          <span class="sr-only" id="loading"></span>
        </div>
      </div>
    </div>
  </div>
</div>
